module.exports = __webpack_public_path__ + "img/customized_m.c7a40210.jpg";